import { useRef, useEffect } from 'react';

/**
 * Custom hook for filter tooltip management.
 * Handles outside click detection and provides refs for tooltip/button elements.
 *
 * @param {boolean} isOpen - Whether the tooltip is currently visible
 * @param {function} onClose - Callback to close the tooltip
 * @returns {{ tooltipRef: React.RefObject, buttonRef: React.RefObject }}
 */
export function useTooltip(isOpen, onClose) {
    const tooltipRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;

        function handleClickOutside(event) {
            if (
                tooltipRef.current &&
                !tooltipRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                onClose();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, onClose]);

    return { tooltipRef, buttonRef };
}
